import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Reveal } from '../components/ui-bits';
import { getNewsItem } from '../lib/api';
import Seo from '../components/Seo';

export default function NewsItem() {
  const { slug } = useParams();
  const [n, setN] = useState(null);
  useEffect(() => { getNewsItem(slug).then(setN).catch(() => {}); }, [slug]);
  if (!n) return <div className="pt-48 pb-24 text-center text-[#6b6b6b]">Loading…</div>;

  return (
    <article data-testid="news-item-page" className="bg-white">
      <Seo
        title={n.title}
        description={n.excerpt.slice(0, 300)}
        path={`/news/${n.slug}`}
        image={n.cover && n.cover.startsWith('http') ? n.cover : undefined}
        type="article"
      />
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 pt-32 lg:pt-40">
        <Link to="/news" className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-[#002b5c] gold-underline">
          <ArrowLeft size={14} /> All News
        </Link>
      </div>
      <header className="max-w-[1200px] mx-auto px-6 lg:px-10 pt-10 pb-14 text-center">
        <Reveal>
          <p className="eyebrow">{n.category} · {new Date(n.published_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
          <h1 className="font-heading uppercase text-[#002b5c] text-4xl sm:text-5xl md:text-6xl lg:text-7xl mt-6 leading-[0.9]">{n.title}</h1>
        </Reveal>
      </header>
      <div className="img-hover overflow-hidden aspect-[16/10] max-w-[1200px] mx-auto rounded-2xl bg-[#faf8f4]">
        <img
          src={n.cover}
          alt={n.title}
          className="w-full h-full object-contain"
        />
      </div>
      <div className="max-w-[760px] mx-auto px-6 lg:px-0 py-20 text-lg leading-[1.9] text-[#333]">
        <p className="font-heading text-2xl md:text-3xl leading-[1.35] text-[#002b5c] mb-10">{n.excerpt}</p>
        {n.body.split('\n\n').map((p, i) => <p key={`p-${i}-${p.slice(0, 12)}`} className="mb-6 font-light">{p}</p>)}
      </div>
    </article>
  );
}
